export default interface IUser {
  id: number;
  name: string;
  email: string;
  type: enUserType;
  avatar: string;
  clicodeduzz: string;
  is_support?: boolean;
  support_id?: number;
}

export enum enUserType {
  'learner' = 0,
  'producer' = 1
}
